import { render } from "./AsahiProgress.vue?vue&type=template&id=b5f0befa&scoped=true"
import script from "./AsahiProgress.vue?vue&type=script&lang=js"
export * from "./AsahiProgress.vue?vue&type=script&lang=js"

import "./AsahiProgress.vue?vue&type=style&index=0&id=b5f0befa&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f0befa"]])

export default __exports__